import { BPButton } from "@/components/bp/bpbutton";
import { ActionProps, CombinatorSelectorProps, NotToggle, NotToggleProps, ValueSelector } from "react-querybuilder";
import { Button, ButtonGroup, Icon } from "@/components/bp/bp-ui";

export function CustomCombinatorSelector(props: CombinatorSelectorProps) {
    if (props.rules.length < 2)
        return null;

    // console.log('CustomCombinatorSelector props:', props);
    return <ValueSelector {...props} />;

    const options = [
        { key: 'and', text: 'AND', value: 'and' },
        { key: 'or', text: 'OR', value: 'or' },
    ];

    return <ButtonGroup>
        {options.map(option => (
            <BPButton
                primary
                active={props.value === option.value}
                key={option.key}
                onClick={() => props.handleOnChange(option.value)}>
                {option.text}
            </BPButton>
        ))}
    </ButtonGroup>

    // return <Select value={props.value} onChange={(e, { value }) => props.handleOnChange(value)} options={options} />;
}

export function CustomNotToggle(props: NotToggleProps) {
    // if (props.ruleGroup.)
    return <NotToggle {...props} />;
}

export function CustomAddRuleAction(props: ActionProps) {
    const { handleOnClick, label } = props;
    return <BPButton compact primary onClick={handleOnClick} className={props.className}><Icon name='add' />{'Rule'}</BPButton>;
}

export function CustomAddGroupAction(props: ActionProps) {
    const { handleOnClick, label } = props;
    return <BPButton compact primary onClick={handleOnClick} className={props.className}><Icon name='add' />{'Group'}</BPButton>;
}

export function CustomRemoveGroupAction(props: ActionProps) {
    const { handleOnClick, label } = props;
    return <BPButton compact negative icon onClick={handleOnClick} className={props.className}><Icon name='x' /></BPButton>;
}


export function CustomRemoveRuleAction(props: ActionProps) {
    const { handleOnClick, label } = props;
    return <BPButton compact negative icon onClick={handleOnClick} className={props.className}><Icon name='x' /></BPButton>;
}
